import { NodeType } from "@store/connections/actionTypes";

export enum EQUIPMENT_TYPES {
  SET_AVAILABLE_EQUIPMENT = "SET_AVAILABLE",
  CREATE_AVAILABLE_EQUIPMENT = "CREATE_AVAILABLE_EQUIPMENT",
  EDIT_AVAILABLE_EQUIPMENT = "EDIT_AVAILABLE_EQUIPMENT",
  DELETE_AVAILABLE_EQUIPMENT = "DELETE_AVAILABLE_EQUIPMENT",
  //
  SET_WORK_EQUIPMENT = "SET_WORK_EQUIPMENT",
  ADD_WORK_EQUIPMENT = "ADD_WORK_EQUIPMENT",
  EDIT_WORK_EQUIPMENT = "EDIT_WORK_EQUIPMENT",
  DELETE_WORK_EQUIPMENT = "DELETE_WORK_EQUIPMENT",
}

export enum EQUIPMENT_TYPE {
  NETWORK = "NETWORK",
  ELECTRICAL = "ELECTRICAL",
}

interface IEquipment {
  readonly id: string;
  readonly name: string;
  readonly type: EQUIPMENT_TYPE;
  readonly info?: string;
  readonly color: string; // - hex
}

export interface IWorkEquipment extends IEquipment {
  readonly num: number;
  readonly on?: boolean;
  readonly subtype?: NodeType
}

export const isWorkEquipment = (eq: IEquipment): eq is IWorkEquipment => (eq as IWorkEquipment).num !== undefined;

export interface IAvailableEquipment extends IEquipment { }

export interface ActionEquipmentBase {
  readonly type: EQUIPMENT_TYPES;
}

export interface ActionSetEquipment extends ActionEquipmentBase {
  readonly payload: IWorkEquipment[];
}

export interface ActionCreateEquipment extends ActionEquipmentBase {
  readonly payload: IAvailableEquipment;
}

export interface ActionEditEquipment extends ActionEquipmentBase {
  readonly payload: IAvailableEquipment;
}

export interface ActionDeleteEquipment extends ActionEquipmentBase {
  readonly payload: string;
}
